import { render, staticRenderFns } from "./manage-booking-receipt-info-header.vue?vue&type=template&id=c9944492&scoped=true"
import script from "./manage-booking-receipt-info-header.vue?vue&type=script&lang=ts"
export * from "./manage-booking-receipt-info-header.vue?vue&type=script&lang=ts"
import style0 from "./manage-booking-receipt-info-header.vue?vue&type=style&index=0&id=c9944492&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9944492",
  null
  
)

export default component.exports